<template>
  <button  class="btn-plus" :class="{'btn-plus--disabled': isLocked}">
    <LockIcon class="btn-plus__lock" v-if="isLocked"/>
    <PlusIcon class="btn-plus__plus" v-else />
  </button>
</template>

<script setup>
  import PlusIcon from "@shared/UI/Svg/ui/Plus.vue";
  import LockIcon from "@shared/UI/Svg/ui/Lock.vue";

  //----------------------------------------
  defineProps({
    isLocked: { type: Boolean, default: false }
  });
</script>

<style lang="scss" scoped>
  @import "./styles.scss"
</style>